import {ChangeDetectionStrategy, Component, Input, signal} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MatIcon} from "@angular/material/icon";
import {gjørDersomIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {BrukerkontekstAdministrasjon} from "felles-ng2/tjenester/BrukerkontekstAdministrasjon";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";
import {MedlemmerListKomponent} from "web-ng2/moduler/medlem/komponenter/medlemmer-list/medlemmer-list";
import {MedlemmerVisKomponent} from "web-ng2/moduler/medlem/komponenter/medlemmer-vis/medlemmer-vis";
import {GruppeModell, MedlemId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

const debug = initDebugger('MedlemmerHovedKomponent');

export type MedlemmerVisningsmodus = 'liste' | 'kort';

@Component({
    selector: 'medlemmer-hoved',
    templateUrl: 'medlemmer-hoved.html',
    styleUrl: 'medlemmer-hoved.scss',
    imports: [
        TranslateModule,
        MatButtonToggleGroup,
        MatButtonToggle,
        MatIcon,
        ReactiveFormsModule,
        MedlemmerListKomponent,
        MedlemmerVisKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemmerHovedKomponent {
    static ajsSelector = 'medlemmerHoved';

    visningsmodusKontroll = new FormControl<MedlemmerVisningsmodus>('kort', {nonNullable: true});
    navigasjonDeaktivert = this.navigasjonDeaktivering.navigasjonDeaktivertSomSignal

    gruppeSomSignal = signal<GruppeModell | null>(null);
    valgtMedlemSomSignal = signal<MedlemId | null>(null);


    constructor(private kontekst: BrukerkontekstTilbyder, private kontekstAdministrasjon: BrukerkontekstAdministrasjon, private navigasjonDeaktivering: NavigasjonDeaktivering) {
        gjørDersomIkkeNil(this.kontekst.autentisertBruker().brukervalg.medlemmerVisningsmodus, modus => this.visningsmodusKontroll.setValue(modus));
        //lagre valgt visningsmodus i brukervalg
        this.visningsmodusKontroll.valueChanges.pipe(takeUntilDestroyed()).subscribe(modus => this.kontekstAdministrasjon.oppdaterBrukervalg({medlemmerVisningsmodus: modus}));
    }

    //ikke def som input() da dette ikke fungerer når komponent kalles fra ajs
    @Input({required: true}) set gruppe(gruppe: GruppeModell) {
        this.gruppeSomSignal.set(gruppe);
    }


    //ikke def som input() da dette ikke fungerer når komponent kalles fra ajs
    @Input() set valgtMedlemId(id: MedlemId | null) {
        this.valgtMedlemSomSignal.set(id);
    }


    // [valgt-medlem-id]="$ctrl.valgtMedlemId"

}

